import { cn } from '../utils/cn';

type StatCardProps = {
    count: string | number;
    label: string;
    icon: React.ReactNode;
    className?: string;
};

export function StatCard({ count, label, icon, className }: StatCardProps) {
    return (
        <div
            className={cn(
                'grid w-72 min-w-[18rem] grid-cols-[56px_1fr] items-start gap-4 rounded-lg border border-gray-300 bg-white px-6 py-6',
                'dark:border-gray-700 dark:bg-gray-800',
                className,
            )}
        >
            <figure className="flex items-center justify-center [&>svg]:h-12 [&>svg]:w-12">{icon}</figure>
            <div>
                <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{count}</p>
                <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">{label}</p>
            </div>
        </div>
    );
}

export function StatCardsRow({ children, className }: { children: React.ReactNode; className?: string }) {
    return (
        <div className={cn('overflow-x-auto scroll-smooth pb-1', className)}>
            <div className="grid grid-flow-col gap-5">{children}</div>
        </div>
    );
}
